import { useState, type FormEvent } from "react";

type SubmitFormProps = {
  variant?: "inline" | "modal";
  onSubmit: (summary: string) => void;
};

const categories = ["幕后剧组风波", "产品未公开内测", "资金流向疑点", "消费维权线报", "校园匿名投稿", "职场内部消息"];
const sourceLevels = ["独家来源", "线人投稿", "匿名投稿"];

export default function SubmitForm({ variant = "inline", onSubmit }: SubmitFormProps) {
  const [category, setCategory] = useState(categories[0]);
  const [sourceLevel, setSourceLevel] = useState(sourceLevels[1]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [anonymous, setAnonymous] = useState(true);
  const [ghost] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (ghost.trim()) return;
    if (!title.trim()) {
      onSubmit("error:请先填写线报标题");
      return;
    }
    onSubmit(`线报「${title.trim()}」已进入初筛队列，编辑会尽快交叉验证`);
    setTitle("");
    setContent("");
  };

  const compact = variant === "modal";
  const fieldClass =
    "w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400";

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className={compact ? "grid grid-cols-1 gap-4" : "grid grid-cols-1 gap-4 sm:grid-cols-2"}>
        <label className="flex flex-col gap-2">
          <span className="text-xs font-label font-medium text-foreground-700">所属话题</span>
          <select value={category} onChange={(e) => setCategory(e.target.value)} className={`${fieldClass} cursor-pointer`}>
            {categories.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-2">
          <span className="text-xs font-label font-medium text-foreground-700">信源等级</span>
          <select value={sourceLevel} onChange={(e) => setSourceLevel(e.target.value)} className={`${fieldClass} cursor-pointer`}>
            {sourceLevels.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
      </div>

      <label className="flex flex-col gap-2">
        <span className="text-xs font-label font-medium text-foreground-700">线报标题</span>
        <input
          name="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="一句话说清这条爆料最关键的点"
          className={fieldClass}
        />
      </label>

      <label className="flex flex-col gap-2">
        <span className="flex items-center justify-between text-xs font-label font-medium text-foreground-700">
          <span>线报详情</span>
          <span className={content.length > 500 ? "text-primary-600" : "text-foreground-500"}>
            {content.length}/500
          </span>
        </span>
        <textarea
          name="content"
          value={content}
          maxLength={500}
          rows={compact ? 4 : 5}
          onChange={(e) => setContent(e.target.value)}
          placeholder="补充时间、地点、你见到的细节，以及是否有其他信息可以交叉验证（最多 500 字）"
          className={`${fieldClass} resize-none`}
        />
      </label>

      <label className="flex cursor-pointer items-center gap-2.5">
        <input
          type="checkbox"
          checked={anonymous}
          onChange={(e) => setAnonymous(e.target.checked)}
          className="h-4 w-4 cursor-pointer accent-[oklch(var(--primary-500))]"
        />
        <span className="text-xs text-foreground-700">匿名投稿，不展示任何可识别我个人身份的信息</span>
      </label>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-ghost-field"
      />

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <button
          type="submit"
          className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-send-plane-fill text-base" />
          提交线报
        </button>
        <span className="text-[11px] text-foreground-500">
          演示环境：提交不会真正上传，仅用于展示交互效果。
        </span>
      </div>
    </form>
  );
}